import { storage } from '~/stores/LocalStorage';

import { isRecord } from '../../domain/guards';

/** `localStorage` key of the last known outcome of the club entry points. */
export const CLUB_ENTRY_HINT_KEY = 'membership:club-entry-shown';

/**
 * Whether the club entry points showed for `customerId` the last time the
 * offer resolved; `null` when unknown (another customer, nothing saved, a
 * storage that throws). Read after mount only.
 */
export const readClubEntryHint = (
  customerId: string | null,
): boolean | null => {
  if (!customerId) {
    return null;
  }
  try {
    const parsed: unknown = JSON.parse(
      storage.getItem(CLUB_ENTRY_HINT_KEY) ?? 'null',
    );
    return isRecord(parsed) &&
      parsed.customerId === customerId &&
      typeof parsed.shown === 'boolean'
      ? parsed.shown
      : null;
  } catch {
    return null;
  }
};

/** Remembers whether the club entry points showed for `customerId`; a storage that throws is ignored. */
export const saveClubEntryHint = (
  customerId: string | null,
  shown: boolean,
): void => {
  if (!customerId) {
    return;
  }
  try {
    storage.setItem(CLUB_ENTRY_HINT_KEY, JSON.stringify({ customerId, shown }));
  } catch {
    return;
  }
};
